// extracted by mini-css-extract-plugin
export default {"flexField":"TaxTypeCreatorModal_flexField__u+fh1","marginRight_20px":"TaxTypeCreatorModal_marginRight_20px__bUXNs"};